var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRefineIcon = function SvgRefineIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M5.318 2.971c-.645 0-1.168.521-1.172 1.165v.016A1.173 1.173 0 1 0 5.318 2.97m0-1.333c-1.153 0-2.124.779-2.416 1.84H1.639a.667.667 0 0 0 0 1.333h1.263a2.507 2.507 0 0 0 4.807.087h4.85a.667.667 0 1 0 0-1.333H7.758a2.51 2.51 0 0 0-2.439-1.927m5.074 9.596h2.183a.667.667 0 1 0 0-1.333h-2.183a2.507 2.507 0 0 0-4.833 0H1.64a.667.667 0 0 0 0 1.333h3.92a2.507 2.507 0 0 0 4.833 0m-3.59-.666a1.173 1.173 0 1 1 2.347 0 1.173 1.173 0 0 1-2.346 0",
    clipRule: "evenodd"
  })));
};
export default SvgRefineIcon;